import { useEffect, useRef } from 'react';
import { supabase } from '@/integrations/supabase/client';

export function useProactiveAI(userId?: string) {
  const startedRef = useRef(false);

  useEffect(() => {
    if (!userId) return;
    if (startedRef.current) return;

    startedRef.current = true;

    let interval: ReturnType<typeof setInterval> | null = null;

    const trigger = () => {
      supabase.functions.invoke('ai-proactive-engage', {
        body: { user_id: userId },
      }).catch((err) => {
        console.error('[AI-PROACTIVE] error:', err);
      });
    };

    trigger();
    interval = setInterval(trigger, 3 * 60 * 1000);

    return () => {
      if (interval) clearInterval(interval);
      startedRef.current = false;
    };
  }, [userId]);
}
